function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFullScreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_44",
    "data-name": "Layer 44"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52,10.5H41.12a1.51,1.51,0,0,0-1.39,2.05c-.09.27,4.52,4.62,4.71,4.89L36.8,25.08a1.5,1.5,0,1,0,2.12,2.12l7.64-7.64,4.38,4.38a1.51,1.51,0,0,0,2.56-1.06V12A1.5,1.5,0,0,0,52,10.5Z",
    id: "id_101",
    style: {
      fill: "rgb(252, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.56,17.44c.19-.26,4.81-4.62,4.71-4.89a1.51,1.51,0,0,0-1.39-2.05H12A1.5,1.5,0,0,0,10.5,12V22.88a1.51,1.51,0,0,0,2.05,1.39c.24.12,4.64-4.53,4.89-4.71l7.64,7.64a1.5,1.5,0,1,0,2.12-2.12Z",
    id: "id_102",
    style: {
      fill: "rgb(245, 253, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.08,36.8l-7.64,7.64c-.26-.19-4.62-4.81-4.89-4.71a1.51,1.51,0,0,0-2.05,1.39V52A1.5,1.5,0,0,0,12,53.5H22.88a1.51,1.51,0,0,0,1.39-2c.12-.24-4.53-4.64-4.71-4.89l7.64-7.64A1.5,1.5,0,0,0,25.08,36.8Z",
    id: "id_103",
    style: {
      fill: "rgb(242, 249, 250)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.39,40.58a1.5,1.5,0,0,0-2.45-.52l-4.38,4.38L38.92,36.8a1.5,1.5,0,0,0-2.12,2.12l7.64,7.64-4.38,4.38a1.51,1.51,0,0,0,1.06,2.56H52A1.5,1.5,0,0,0,53.5,52V41.12A1.41,1.41,0,0,0,53.39,40.58Z",
    id: "id_104",
    style: {
      fill: "rgb(240, 248, 250)"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullScreen);
export default __webpack_public_path__ + "static/media/full_screen.b0e001dd83411fb2f10bc5f64b656bb2.svg";
export { ForwardRef as ReactComponent };